//-----------------------------------------------//
// Place all global CSS for every page here //
//-----------------------------------------------//

import { base } from "./foundations/typography"

const globalCSS = {
	/********* UTILITY CLASSES *********/

	main: { overflowX: "hidden", maxW: "100vw" },

	body: { overflowX: "hidden", maxW: "100vw" },

	"body.chakra-ui-light *:focus": { outline: "none" },

	".stop-scroll": {
		overflow: "hidden",
	},

	".hidden": {
		display: "none",
	},

	"::selection": {
		backgroundColor: "primary.300",
		color: "dark.default",
	},

	".bg-image.gatsby-image-wrapper": {
		w: "100vw",
		h: "100%",
		position: "absolute",
		zIndex: "-2",
		left: "0",
		top: "0",
		objectFit: "cover",
	},

	...base,
}

const globalStyle = {
	global: {
		...globalCSS,
	},
}

export { globalStyle as styles }
